import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useScrollAnimation from "./UseScrollAnimation";
import { useNavigate } from 'react-router-dom';

const produtos = [
  { nome: "INTERFOLHA DUAS DOBRAS - US210", imagem: "/1-000001-2-1.jpg" },
  { nome: "SERRA FITA PARA ROLÃO – USR800T", imagem: "/SERRA FITA PARA ROLÃO – USR800.jpg" },
  { nome: "PRENSA ENFARDADEIRA - US690", imagem: "/PRENSA ENFARDADEIRA - US690.jpg" },
  { nome: "INTERFOLHA DUAS DOBRAS VÁCUO - US1300", imagem: "/INTERFOLHA DUAS DOBRAS VÁCUO - US1300.jpg" },
  { nome: "TUBETEIRA – US80", imagem: "/TUBETEIRA – US80.jpg" },
  { nome: "REBOBINADEIRA – US3000", imagem: "/REBOBINADEIRA – US3000.jpg" },
];

const Produtos = () => {
  useScrollAnimation();
  const navigate = useNavigate();

  const handleCardClick = (produto) => {
    navigate(`/equipamento/${encodeURIComponent(produto.nome)}`, { state: produto });
  };

  return (
    <section id="produtos" className="py-20 md:py-32 bg-white overflow-hidden reveal">
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-12 md:mb-20 text-left">
          
          {/* NOVO DESIGN DO RÓTULO (SEM CARD / ESTILO ENGENHARIA) */}
          <div className="flex items-center gap-4 mb-6">
            <span className="w-12 h-[3px] bg-usifresa-orange"></span>
            <span className="text-xs md:text-sm font-black text-usifresa-blue uppercase tracking-[0.3em]">
              Nossos Produtos
            </span>
          </div>
          
          <h2 className="font-sans text-[2.2rem] leading-[1.1] md:text-6xl font-black text-usifresa-dark mb-6">
            Inovação e qualidade <br className="hidden md:block" /> aplicada no mercado.
          </h2>
          <p className="text-base md:text-xl text-usifresa-dark/70 font-medium max-w-3xl">
            Contamos em nossa fábrica com máquinas e equipamentos de última geração que proporcionam alta qualidade e padronização dos nossos produtos. Investimos continuamente em tecnologia.
          </p>
        </div>

        {/* MÁGICA AQUI: O w-[calc(50vw+50%)] faz a caixa esticar exatamente até a borda direita da tela */}
        <div className="relative group/swiper pb-12 w-[calc(50vw+50%)]">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            spaceBetween={24}
            breakpoints={{
              320: { slidesPerView: 1.1, spaceBetween: 16 },
              640: { slidesPerView: 2.2, spaceBetween: 24 },
              1024: { slidesPerView: 3.2, spaceBetween: 24 },
              1280: { slidesPerView: 3.5, spaceBetween: 32 },
            }}
            // Ajustado para compensar a margem apenas na esquerda e dar um respiro no final da direita
            className="pb-16 !pl-4 -ml-4 !pr-6 md:!pr-12 lg:!pr-32"
          >
            {produtos.map((produto, index) => (
              <SwiperSlide key={index}>
                <div 
                  onClick={() => handleCardClick(produto)}
                  className="rounded-[2rem] overflow-hidden shadow-xl hover:shadow-2xl relative bg-usifresa-dark h-[400px] md:h-[500px] cursor-pointer group transition-all duration-500 transform hover:-translate-y-2 border border-gray-100"
                >
                  <div className="relative h-full w-full">
                    <img
                      src={produto.imagem}
                      alt={produto.nome}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 z-10"
                    />
                    
                    <div className="absolute bottom-0 left-0 right-0 h-[45%] md:h-[45%] bg-gradient-to-t from-usifresa-dark via-usifresa-dark/80 to-transparent z-20 pointer-events-none transition-opacity duration-300" />
                    
                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 z-30 flex flex-col justify-end gap-4 h-full pointer-events-none">
                      <div className="flex-1 flex flex-col justify-end">
                        <h3 className="text-lg md:text-2xl text-white font-black leading-tight max-w-[90%] transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                          {produto.nome}
                        </h3>
                      </div>
                      
                      <button 
                        className="pointer-events-auto self-start mt-2 bg-usifresa-light-blue text-usifresa-dark group-hover:bg-white group-hover:text-usifresa-dark transition-all duration-300 font-bold tracking-tighter text-[10px] md:text-xs h-10 px-6 rounded-full inline-flex items-center"
                      >
                        VER DETALHES
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="text-center mt-4 pr-0 md:pr-12 lg:pr-0">
          <button 
            onClick={() => navigate('/produtos')}
            className="w-full sm:w-auto bg-usifresa-dark text-white hover:bg-usifresa-light-blue hover:text-usifresa-dark text-xs font-bold tracking-widest uppercase px-10 py-5 h-auto rounded-full transition-all duration-300 shadow-lg"
          >
            VER TODOS OS PRODUTOS
          </button>
        </div>
      </div>
    </section>
  );
};

export default Produtos;